import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import * as styles from "./PasswordStrength.scss";

export interface IPasswordStrengthProps {
    password: string;
}

// https://stackoverflow.com/questions/948172/password-strength-meter
function scorePassword(pass: string): number {
    let score = 0;
    if (pass.length === 0) {
        return score;
    }

    const letters: Record<string, number> = {};
    for (const letter of pass) {
        letters[letter] = (letters[letter] || 0) + 1;
        score += 5.0 / letters[letter];
    }

    let variationCount = 0;
    if (/\d/.test(pass)) {
        variationCount++;
    }
    if (/[a-z]/.test(pass)) {
        variationCount++;
    }
    if (/[A-Z]/.test(pass)) {
        variationCount++;
    }
    if (/\W/.test(pass)) {
        variationCount++;
    }

    score += (variationCount - 1) * 10;

    if (score > 80) {
        return 3;
    }
    if (score > 60) {
        return 2;
    }
    if (score >= 30) {
        return 1;
    }
    return 0;
}

@observer
export class PasswordStrength extends Component<IPasswordStrengthProps> {
    public render() {
        const { password } = this.props;

        let strength = 0;
        if (password.length >= 8) {
            strength = scorePassword(password);
        }

        return (
            <div className={styles["password-strength"]}>
                <div
                    className={classnames(
                        styles.bar,
                        strength >= 0 ? styles.active : null,
                    )}
                />
                <div
                    className={classnames(
                        styles.bar,
                        strength >= 1 ? styles.active : null,
                    )}
                />
                <div
                    className={classnames(
                        styles.bar,
                        strength >= 2 ? styles.active : null,
                    )}
                />
                <div
                    className={classnames(
                        styles.bar,
                        styles.last,
                        strength >= 3 ? styles.active : null,
                    )}
                />
                <div className={styles["left-title"]}>weak</div>
                <div className={styles["right-title"]}>strong</div>
            </div>
        );
    }
}
